<template>
	<div id="app">
		<router-view :key="key"></router-view>
	</div>
</template>

<script>
    export default {
        name: 'App',
        components: {
            xFooter: () => import('@/components/zh-cn/footer')
        },
        data: function () {
            return {
                componentInfo: {
                    path: '',
                    name: '',
                },
                activeSideIndex: []
            };
        },
        computed: {
            key() {
                return this.$route.name !== undefined ? this.$route.name + new Date() : this.$route + new Date()
            }
        },
        methods: {},
        mounted() {
            const _this = this;
            const navigatorObject = require('@/lib/common');
            const commonMethods = navigatorObject.default;
            if (true) {
                (function (doc, win) {
                    var docEl = doc.documentElement,
                    resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize',
                    recalc = function () {
                        var clientWidth = docEl.clientWidth;
                        if (!clientWidth) return;
                        if (commonMethods._isMobile() && !commonMethods._isPc()) {
                            docEl.style.fontSize = 16 * (clientWidth / 750) + 'px';
                        } else {
                            if (clientWidth <= 1240) {
                                docEl.style.fontSize = 16 * (1240 / 1904) + 'px';
                            } else {
                                docEl.style.fontSize = 16 * (clientWidth / 1904) + 'px';
                            }
                        }
                    };

                    if (!doc.addEventListener) return;
                    win.addEventListener(resizeEvt, recalc, false);
                    doc.addEventListener('DOMContentLoaded', recalc, false);
                })(document, window);
            }
        },
        created() {

        }
    }
</script>

<style>

	body {
		border: none;
		overflow-y: auto;
		overflow-x: hidden;
		margin: 0;
		padding: 0;
	}

	#app {
		font-family: "Open Sans";
		-webkit-font-smoothing: antialiased;
		-moz-osx-font-smoothing: grayscale;
		text-align: center;
		color: #2c3e50;
		margin-top: 0px;
		border: none;
	}

	#app {
		border: none;
		margin: 0;
		padding: 0;
	}
</style>



// WEBPACK FOOTER //
// src/App.vue